import React from 'react';
import { Alert } from 'react-bootstrap';
import { browserHistory } from 'react-router';

class Notification extends React.Component {

    onDelete = () => {
        this.props.onRemoveNotification(this.props.item)
    }

    onRedirect = () => {
        browserHistory.push(`/tours/${this.props.item.tour.id}/hotels/3`);
    }
    render() {

        const { hotel_name, tour_name, variant } = this.props
        return (<Alert bsStyle={variant}>
            <div className="row">
                <div className="col-xs-1" >
                    <i className="fa fa-lg fa-bell" aria-hidden="true" style={{ color: 'grey' }} />
                </div>
                <div className="col-xs-10" onClick={this.onRedirect}>
                    Mail Delivery to <b>{hotel_name}</b> for Travel Group <b>{tour_name}</b> has failed
                </div>
                <div className="col-xs-1">
                    <i className="fa fa-trash" aria-hidden="true" style={{ color: 'red', cursor: 'pointer' }} onClick={this.onDelete} />
                </div>
            </div>
        </Alert>
        )
    }
}

export default Notification;


// WEBPACK FOOTER //
// src/routes/notification/components/Notification.js